<template>
  <section
    class="w-[80mm] px-2 pb-1 pt-0 for-print-only"
    :class="[pageBreakAfter ? 'break-after-page' : '']"
  >
    <!--       odd % 2 === 1 ? 'break-page' : ''-->
    <div class="">
      <div
        class="flex flex-row gap-2 items-center mb-2 justify-center font-bold"
      >
        <TheLogo class="w-4 h-4" />
        <div class="uppercase text-sm ml-2">Mộc Châu Island</div>
      </div>
      <table class="border-none white mb-2 table_invoice-info table-auto">
        <tbody>
          <tr>
            <td class="border-none">Ngày:</td>
            <td class="border-none">{{ date }}</td>
          </tr>
          <tr>
            <td class="border-none">Số hóa đơn:</td>
            <td class="border-none">{{ invoice_code }}</td>
          </tr>
          <tr>
            <td class="border-none">Thời gian in:</td>
            <td class="border-none">{{ print_time }}</td>
          </tr>
          <!-- <tr>
            <td>Quầy bán vé:</td>
            <td>{{ ticket_office_nm }}</td>
          </tr> -->
          <tr>
            <td class="border-none">Số vé:</td>
            <td class="border-none">{{ ticket_number }}</td>
          </tr>
          <tr>
            <td class="border-none">Ngày sử dụng:</td>
            <td class="border-none">{{ apply_date }}</td>
          </tr>
        </tbody>
      </table>
      <div class="w-28 mb-1 mx-auto">
        <img class="w-full" :src="`data:image/png;base64, ${qr}`" />
      </div>
      <div
        class="font-bold text-xs tracking-tight leading-tight text-center mb-4 px-2"
      >
        {{ ticket_nm }}<br />{{ $displayCurrency(price) }} VNĐ
      </div>
      <!-- <div class="font-bold text-xl tracking-tight leading-tight text-center mb-8 px-2">
        {{ $displayCurrency(price) }} VNĐ
      </div> -->
      <div class="text-center pb-2 leading-tight">
        <p class="text-[8pt]">Vé không hoàn/đổi/hủy sau khi sử dụng</p>
        <p class="text-[8pt]">
          Ticket cannot be cancelled/reimbursed/exchange when used
        </p>
      </div>
      <!-- <div class="text-center italic pb-[12pt] leading-tight">
        <p class="mt-4">Thank you</p>
      </div> -->
      <div class="text-center py-2">
        <p class="text-[8pt]" style="font-style: italic">
          Thank you for choosing Moc Chau Island
        </p>
      </div>
      <div class="bg-black h-1 w-1 mx-auto"></div>
    </div>
  </section>
</template>

<script>
import TheLogo from '@/views/mci/reception/components/TheLogo.vue'

export default {
  components: {
    TheLogo
  },
  props: [
    'pageBreakAfter', //  use this for page break when print ticket, if not multiple ticket might be printed in one page
    'date',
    'invoiceCode',
    'printDate',
    'ticketOfficeName',
    'ticketName',
    'applyDate',
    'qr',
    'ticketNumber',
    'print_time',
    'createDate',
    'price',
    //
    'apply_date',
    'print_date',
    'cancel',
    'invoice_code',
    'ticket_nm',
    'ticket_number',
    'ticket_office_nm',

    'odd'
  ],
  mounted() {
    setTimeout(() => {
      console.log('FASZXVXV', this.props)
    }, 1000)
  }
}
</script>

<style scoped>
@media print {
  .for-print-only {
    padding: 5pt;
    padding-top: 1pt;
    border: none;
    page-break-inside: avoid;
  }
}
table {
  font-size: 7pt;

  width: 100%;
}

.table_invoice-info td {
  font-size: 8pt;
  padding: 2pt;
  padding-left: 4pt;
  padding-right: 4pt;
}
.table_invoice-info tr td:nth-child(1) {
  width: 1px;
  white-space: nowrap;
  padding-right: 8pt;
  font-weight: 600;
}

.table_items-detail th,
.table_items-detail td {
  font-size: 7pt;
  padding: 6pt;
  padding-left: 4pt;
  padding-right: 4pt;
}
.table_items-detail tr:nth-child(odd) td {
  padding-bottom: 0;
}
.w-\[80mm\] {
  width: 80mm;
}
.px-2 {
  padding-left: 0.5rem /* 8px */;
  padding-right: 0.5rem /* 8px */;
}
.pb-1 {
  padding-bottom: 0.25rem /* 4px */;
}
.pt-0 {
  padding-top: 0px;
}
.break-after-page {
  break-after: page;
}
.flex {
  display: flex;
}
.flex-row {
  flex-direction: row;
}
.gap-2 {
  gap: 0.5rem /* 8px */;
}
.items-center {
  align-items: center;
}
.mb-2 {
  margin-bottom: 0.5rem /* 8px */;
}
.justify-center {
  justify-content: center;
}
.font-bold {
  font-weight: 700;
}
.w-4 {
  width: 1rem /* 16px */;
}
.h-4 {
  height: 1rem /* 16px */;
}
.uppercase {
  text-transform: uppercase;
}
.text-sm {
  font-size: 0.875rem /* 14px */;
  line-height: 1.25rem /* 20px */;
}
.ml-2 {
  margin-left: 0.5rem /* 8px */;
}
.border-none {
  border: none;
}
.mb-2 {
  margin-bottom: 0.5rem /* 8px */;
}
.table-auto {
  table-layout: auto;
}
.w-28 {
  width: 7rem /* 112px */;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.mb-1 {
  margin-bottom: 0.25rem /* 4px */;
}
.w-full {
  width: 100%;
}
.font-bold {
  font-weight: 700;
}
.text-xs {
  font-size: 0.75rem /* 12px */;
  line-height: 1rem /* 16px */;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.leading-tight {
  line-height: 1.25;
}
.text-center {
  text-align: center;
}
.mb-4 {
  margin-bottom: 1rem /* 16px */;
}
.px-2 {
  padding-left: 0.5rem /* 8px */;
  padding-right: 0.5rem /* 8px */;
}
.pb-2 {
  padding-bottom: 0.5rem /* 8px */;
}
.leading-tight {
  line-height: 1.25;
}
.text-\[8pt\] {
  font-size: 8pt;
}
.pb-\[12pt\] {
  padding-bottom: 12pt;
}
.italic {
  font: italic;
}
.mt-4 {
  margin-top: 16px;
}
.py-2 {
  padding: 8px 0;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.h-1 {
  height: 0.25rem /* 4px */;
}
.w-1 {
  width: 0.25rem /* 4px */;
}
</style>
